import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";

/**
 * Props for `ShareBar`.
 */
export type ShareBarProps = SliceComponentProps<Content.ShareBarSlice>;

/**
 * Component for "ShareBar" Slices.
 */
const ShareBar: FC<ShareBarProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      Placeholder component for share_bar (variation: {slice.variation}) Slices
    </section>
  );
};

export default ShareBar;
